export default {};
throw new Error(`Could not resolve "gsap/InertiaPlugin" imported by "@appletosolutions/reactbits". Is it installed?`)